import React from 'react';
import BamDatabaseView from './BamDatabaseView';

export interface BamDatabaseRouteProps {
  className?: string;
}

const BamDatabaseRoute: React.FC<BamDatabaseRouteProps> = ({ className = '' }) => {
  return (
    <div className={className}>
      <BamDatabaseView />
    </div>
  );
};

export default BamDatabaseRoute;
